<template>
  <div>
    <div class="product-group">
      <div class="form-group">
        <b>Produs</b>
        <input
          v-if="editedAssignmentProduct.need"
          type="text"
          class="vInput form-disabled"
          v-model="editedAssignmentProduct.product.name"
          :disabled="true"
        />

        <v-select
          v-else
          ref="productsCatalog"
          :id="`ID${makeid(6)}`"
          v-model="editedAssignmentProduct.product"
          label="name"
          :options="products"
          :filter="(a, b) => fuseFilter(a, b, 'name')"
        >
          <template #option="o">
            <span class="v-select_li_custom">
              <span
                >{{ o.name }}
                <i v-if="o.status == 'in_progres'" style="pointer-events: none"
                  >(în curs de validare)</i
                ></span
              >
              <i
                v-tooltip="
                  {
                    in_progres: 'În curs de validare',
                    completed: 'Validat',
                  }[o.status]
                "
                :class="
                  {
                    in_progres: 'fad fa-hourglass',
                    completed: 'fas fa-clipboard-check',
                  }[o.status]
                "
                style="margin-right: 0.75rem"
              ></i>
              <i v-tooltip="o.name" class="fas fa-info-circle"></i>
            </span>
          </template>
        </v-select>
      </div>
    </div>
    <div class="product-group">
      <div class="form-group">
        <b>Descriere</b>
        <editor
          key="editedAssignmentProductDescription"
          v-model="editedAssignmentProduct.description"
          minHeight="180"
        />
      </div>
    </div>

    <div class="product-group">
      <div v-if="editedAssignmentProduct.need" class="form-group">
        <b>Valoarea unitară inițială</b>
        <CustomNumberInput
          :value="editedAssignmentProduct.need.estimatedPriceWoTva"
          :disabled="true"
        />
      </div>
      <div class="form-group">
        <b>Valoarea unitară</b>
        <CustomNumberInput v-model="editedAssignmentProduct.unitValue" />
      </div>
    </div>

    <div class="product-group">
      <div v-if="editedAssignmentProduct.need" class="form-group">
        <b>Cotă TVA inițială</b>
        <input
          type="text"
          class="vInput form-disabled"
          :value="assignmentProduct.need.cotaTva + '%'"
          :disabled="true"
        />
      </div>
      <div class="form-group">
        <b>Cotă TVA</b>
        <input
          type="text"
          class="vInput"
          v-model="editedAssignmentProduct.tvaValue"
          @input="updateTva"
        />
      </div>
    </div>

    <div class="product-group">
      <div v-if="editedAssignmentProduct.need" class="form-group">
        <b>Cantitate inițială</b>
        <CustomNumberInput
          :value="editedAssignmentProduct.need.qty"
          :disabled="true"
        />
      </div>
      <div class="form-group">
        <b>Cantitate</b>
        <CustomNumberInput v-model="editedAssignmentProduct.quantity" />
      </div>
    </div>

    <!--  <div class="product-group">
      <div class="form-group">
        <b>Valoarea unitară inițială, cu TVA</b>
        <input
          type="number"
          class="vInput form-disabled"
          v-model="editedAssignmentProduct.need.estimatedPrice"
          :disabled="true"
        />
      </div>
      <div class="form-group">
        <b>Valoarea unitară, cu TVA</b>
        <input
          v-model="editedAssignmentProduct.unitValueWithTva"
          type="number"
          class="vInput "
        />
      </div>
    </div> -->

    <div class="product-group">
      <div v-if="editedAssignmentProduct.need" class="form-group">
        <b>Valoarea totală inițială, fără TVA</b>
        <CustomNumberInput
          :value="editedAssignmentProduct.need.estimatedTotalPriceWoTva"
          :disabled="true"
        />
      </div>
      <div class="form-group">
        <b>Valoarea totală, fără TVA</b>
        <CustomNumberInput
          v-model="editedAssignmentProduct.totalValueWithoutTva"
          :disabled="true"
        />
      </div>
    </div>

    <div class="product-group">
      <div v-if="editedAssignmentProduct.need" class="form-group">
        <b>Valoarea totală inițială, cu TVA</b>
        <CustomNumberInput
          :value="editedAssignmentProduct.need.sumNeed"
          :disabled="true"
        />
      </div>
      <div class="form-group">
        <b>Valoarea totală, cu TVA</b>
        <CustomNumberInput
          v-model="editedAssignmentProduct.totalValueWithTva"
          :disabled="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { PRODUCTS } from "../../api";
import CustomNumberInput from "@/components/CustomNumberInput";
const DEFAULT_DATA = {
  unitValue: "",
  tvaValue: "",
  quantity: "",
  status: "draft",
  unitValueWithTva: "",
  totalValueWithoutTva: "",
  totalValueWithTva: "",
  description: "",
  product: null,
};
export default {
  props: {
    assignmentDocument: { type: Object, required: true },
    assignmentProduct: { type: Object, required: false },
  },
  components: { CustomNumberInput },

  data() {
    return {
      products: [],
      editedAssignmentProduct: this.assignmentProduct || DEFAULT_DATA,
    };
  },
  watch: {
    editedAssignmentProduct: {
      handler(val) {
        const unitValueWithTva = this.prepareTva(
          val.unitValue,
          this.removePercentage(val.tvaValue),
        );

        val.unitValueWithTva = this.exactRound(unitValueWithTva);

        val.totalValueWithoutTva = this.exactRound(
          Number(val.unitValue) * Number(val.quantity),
        );

        val.totalValueWithTva = this.exactRound(
          unitValueWithTva * Number(val.quantity),
        );

        this.$emit("input", {
          ...val,
          tvaValue: this.removePercentage(val.tvaValue),
        });
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async getProducts() {
      let response = await PRODUCTS();

      if (response?.data?.result?.length) {
        const products = response.data.result;

        products.forEach((product) => {
          product.productCpvCode = product.cpvCategory?.cpvCode || "-";
          product.cpvName = product.cpvCategory?.name || "-";
          product.measurementUnit = product.measurementUnit?.shortName || "-";
        });

        return products;
      }

      return [];
    },
    updateTva(event) {
      if (
        event.inputType == "deleteContentBackward" &&
        this.editedAssignmentProduct.tvaValue
      ) {
        this.editedAssignmentProduct.tvaValue =
          this.editedAssignmentProduct.tvaValue.slice(0, -1);
        this.editedAssignmentProduct.tvaValue += "%";
        return;
      }

      event.target.value = this.removePercentage(event.target.value);

      this.editedAssignmentProduct.tvaValue =
        event.target.value.match(/^\d+\.?\d{0,2}$/);

      if (this.editedAssignmentProduct.tvaValue) {
        this.editedAssignmentProduct.tvaValue += "%";
      }
    },

    removePercentage(val) {
      if (!val) return "";
      return val.replace("%", "");
    },
  },
  created() {
    if (this.assignmentProduct?.tvaValue) {
      this.assignmentProduct.tvaValue += "%";
    }

    this.getProducts().then((products) => {
      this.products = products;
    });
  },
};
</script>
<style lang="scss">
.product-group {
  display: flex;
  gap: 5px;
  .form-group {
    flex: 1;
  }
}
</style>
